import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import * as React from 'react';

interface DialogCloseProps {
  handleClose: () => void;
}

const closeIconStyle = {
  position: 'absolute' as 'absolute',
  right: 8,
  top: 8,
  color: (theme: any) => theme.palette.grey[500]
};

const DialogCloseButton: React.FC<DialogCloseProps> = ({ handleClose }) => (
  <div style={{ margin: '0.5rem' }}>
    <IconButton aria-label='close' onClick={handleClose} sx={closeIconStyle}>
      <CloseIcon />
    </IconButton>
  </div>
);

export default DialogCloseButton;
